// Translations
import form from '../sections/form/translations/en'

// Translation: Terms of service > Landing (English)
export default Object.freeze({
	sections: { form }
})
